/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeEvent } from 'src/app/core/models/ge-event/ge-event';
import { EventService } from 'src/app/core/services/ge-event/ge-event.service';
import { Translation } from 'src/app/core/models/internationalization/internationalization';
import { EventCourseCustomerService } from 'src/app/core/services/ge-event-course-customer/ge-event-course-customer.service';
declare function sendData(data: string): string;

@Component({
    selector: 'app-event-detail-net-game-coupon',
    templateUrl: './event-detail-net-game-coupon.component.html',
    styleUrls: ['./event-detail-net-game-coupon.component.css'],
})
export class EventDetailNetGameCouponComponent implements OnInit {
    title?= 'Event';
    nameButtonAction? = 'Scan QR Code to start';
    scheduleText?= 'Schedule';
    isAvailable = '';
    eventId = '';
    shopDid = '';
    geEvent?: GeEvent;
    isReady = false;
    translation?: Translation
    isScanQRCode = true;

    constructor(
        private activeRoute: ActivatedRoute,
        private router: Router,
        private eventService: EventService,
        private eventCourseCustomerService: EventCourseCustomerService,
    ) { }

    ngOnInit(): void {
        this.loadTranslation();
        this.eventId = this.activeRoute.snapshot.params['eventId'];
        this.shopDid = this.activeRoute.snapshot.params['shopDid'];
        this.isAvailable = this.activeRoute.snapshot.params['isAvailable'];
        this.loadDetails(this.eventId);
        this.loadEventCourseCustomer(this.eventId);
    }

    loadTranslation() {
        const translation = sessionStorage.getItem('translation');
        if (translation != null) {
            this.translation = JSON.parse(translation);
            this.title = this.translation?.eventTitle;
            this.nameButtonAction = this.translation?.scanQRCodeButton;
            this.scheduleText = this.translation?.scheduleText;
        }
    }

    private loadDetails(eventId: string) {
        if (eventId) {
            this.eventService.getEvent(eventId).subscribe((result) => {
                this.geEvent = result.event;
                this.isReady = true;
            });
        }
    }

    private loadEventCourseCustomer(eventId: string) {
        this.eventCourseCustomerService.getEventCoursesCustomers(eventId).subscribe((result) => {
            if (result) {
                sessionStorage.setItem('startedEventCourseCustomer','true');
                sessionStorage.setItem('startedCourseId',result.course_id);
                this.nameButtonAction = this.translation?.continuePreviousCourseButton;
                this.isScanQRCode = false;
            }
            else {
                sessionStorage.setItem('startedEventCourseCustomer','false');
                this.isScanQRCode = true;
            }
        })
    }

    goToCourse() {
        const url = `/stamp-rally-net-game-coupon/course/event/${this.eventId}/shop-did/${this.shopDid}/is-available/${this.isAvailable}`;
        this.router.navigate([url]);
    }

    goToQRCode() {
        const url = `/stamp-rally-net-game-coupon/qr-code/event/${this.eventId}/shop-did/${this.shopDid}/is-available/${this.isAvailable}/route/course`;
        this.router.navigate([url]);
    }

    onClose() {
        const close = {
            close: true
        }
        sendData(JSON.stringify(close));
    }
}
